import { Action, createReducer } from '@ngrx/store';
import { IEnvironment } from '../interfaces';

import { getEnvironmentValues } from '../environment.utils';

export const initialState: IEnvironment = getEnvironmentValues();

// tslint:disable-next-line:typedef
export function environmentReducer(existingState: IEnvironment, action: Action) {
  return createReducer(
    initialState,
  )(existingState, action);
}

export const production = (state: IEnvironment) => state.production;
export const restAPI = (state: IEnvironment) => state.restAPI;
